export { BrowserTracing } from './browsertracing';
export { instrumentOutgoingRequests, defaultRequestInstrumentationOptions, } from './request';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/tracing/esm/browser/index.js
// module id = 272
// module chunks = 86